// extracted by mini-css-extract-plugin
export default {"serviceTitle":"ServiceTwo_serviceTitle__yLusE","bestService":"ServiceTwo_bestService__utMSf","icon":"ServiceTwo_icon__D+A90","content":"ServiceTwo_content__U6L26"};